// ==============================|| OVERRIDES - LIST ITEM TEXT ||============================== //

export default function ListItemIcon() {
	return {
		MuiListItemText: {
			styleOverrides: {
				root: {
					fontWeight: 700,
				},
			},
		},
	};
}
